import React from 'react';

const PageLoader = () => {
  return (
    <div className="fixed inset-0 bg-[#0A0F1C] z-50 flex items-center justify-center">
      {/* Animated background gradient */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-emerald-400/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Main loader */}
      <div className="relative z-10 flex flex-col items-center justify-center">
        {/* Spinning ring */}
        <div className="relative w-20 h-20 mb-4">
          <div className="absolute inset-0 border-4 border-slate-700 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-emerald-500 rounded-full animate-spin"></div>
          <div className="absolute inset-0 border-4 border-transparent border-r-emerald-400 rounded-full animate-spin" style={{ animationDuration: '0.8s' }}></div>
          <div className="absolute inset-2 border-4 border-transparent border-b-emerald-600 rounded-full animate-spin" style={{ animationDuration: '1.2s', animationDirection: 'reverse' }}></div>
        </div>

        {/* Pulsing dots */}
        <div className="flex space-x-2">
          <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
          <div className="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>

        {/* Optional: Loading text */}
        <p className="mt-4 text-slate-400 text-sm font-medium">Loading...</p>
      </div>
    </div>
  );
};

export default PageLoader;

